import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { appContext } from '../../../../app.context';

class ConservazioneCaricaDocumentoModelloVersamentoStep2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        '$uibModal',
        'ArchiSmallServices',
        '$filter'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: any,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private ArchiSmallServices: ArchiSmallServices,
        private $filter: ng.IFilterService
    ) {
        $scope.pageHeader = 'Carica Documento';
        $scope.pageSubHeader = 'Inserisci le informazioni obbligatorie per la conservazione';

        if (store.get('conservazioneClasseDocumentale') === null) {
            $state.go('home.conservazione-carica-documento-step1');
            return;
        }

        $scope.classeDocumentale = store.get('conservazioneClasseDocumentale').value;

        $scope.prev = () => {
            $scope.setConservazioneSettings();
            $state.go('home.conservazione-carica-documento-step1', { 'classeDocumentale': $scope.classeDocumentale });
        };

        // <editor-fold desc='openWorkerModal'>
        $scope.openWorkerModal = (size) => {
            $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');

            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'workerModelliVersamentoModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    settings: $scope.settings
                }
            });
        };
        // </editor-fold>

        $rootScope.formsubmitted = false;

        // <editor-fold desc='setConservazioneSettings'>
        $scope.setConservazioneSettings = () => {
            $scope.settings.dataDocumento = $filter('date')($scope.settings.dataDocumento, 'yyyy-MM-dd');
            let classeDocumentale = $scope.settings.classeDocumentale.key;

            let userSettings = {
                'key': classeDocumentale,
                'value': $scope.settings
            };

            ArchiSmallServices.setConservazioneSettings(userSettings)
                .then((response: any) => {
                    // ?
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        // <editor-fold desc='getConservazioneSettings'>
        $scope.getConservazioneSettings = () => {
            $rootScope.readyToUse = false;
            $scope.currentClasseDocumentale = $scope.classeDocumentale;
            ArchiSmallServices.getConservazioneSettings($scope.classeDocumentale)
                .then((response: any) => {
                    if (response !== undefined && response !== '') {

                        $scope.settings = response.value;
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                    } else {
                        $scope.settings = $scope.getSettingsDefault();
                        $scope.settings.classeDocumentale = $scope.currentClasseDocumentale;
                        $scope.filesIndex = $scope.settings.files.length;
                        $rootScope.filesUploadedNumber = $scope.filesIndex;
                    }
                    $rootScope.readyToUse = true;
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        // </editor-fold>

        if ($scope.classeDocumentale !== '') {
            $scope.getConservazioneSettings();
            //                    $state.go('home.conservazione-carica-documento-' + $scope.classeDocumentale + '-step2');
        }

        $scope.dpOpened = {
            dataDocumento: false,
        };
        $scope.openDP = ($event, opened) => {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.dpOpened[opened] = true;
        };
        $scope.autoOpen = ($event, opened) => {
            /* tslint:disable:no-string-literal */
            if (appContext.userBrowser['isIE']) {
                return;
            }
            $event.preventDefault();
            $event.stopPropagation();
            $scope.dpOpened[opened] = true;
        };
    }

}

export const ConservazioneCaricaDocumentoModelloVersamentoStep2Component: ng.IComponentOptions = {
    template: require('./conservazione-carica-documento-modello-versamento-step2.html'),
    controller: ConservazioneCaricaDocumentoModelloVersamentoStep2Controller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-versamento-step2/conservazione-carica-documento-modello-versamento-step2.ts